<template>
	<div
		v-if="ctaBoxes"
		:class="[
			'c-block-list-custom-cta-boxes-custom w-full mb-80 >=768:mb-120',
			ctaBoxes.length == 2 ? '>=768:flex >=768:gap-50' : null,
			ctaBoxes.length > 2
				? '>=768:grid >=768:grid-cols-2 >=768:gap-50'
				: null,
		]"
	>
		<div
			v-for="(box, index) in ctaBoxes"
			:key="index"
			:class="[
				'group',
				ctaBoxes.length == 1
					? 'rounded-8 bg-white overflow-hidden >=768:flex >=768:h-620'
					: null,
				ctaBoxes.length == 2 ? '>=768:w-half' : null,
				ctaBoxes.length > 2 && index == 0
					? 'rounded-8 bg-white overflow-hidden mb-50 >=768:mb-0 >=768:col-span-2 >=768:flex w-full >=768:h-620'
					: null,
			]"
		>
			<div
				v-if="box.content.media"
				:class="[
					'overflow-hidden',
					ctaBoxes.length == 1 ? '>=768:w-half' : null,
					ctaBoxes.length == 2 ? 'rounded-8' : null,
					ctaBoxes.length > 2 && index != 0 ? 'rounded-8' : null,
					ctaBoxes.length > 2 && index == 0 ? '>=768:w-half' : null,
				]"
			>
				<UmbracoImageExt
					class="block w-full"
					:alt="box.content.media.altText"
					:source-url="
						box.content.media.cropUrl || box.content.media.path
					"
					:source-width="box.content.media.width"
					:source-height="box.content.media.height"
					:widths="[320, 417, 768]"
					:aspect-ratio="
						ctaBoxes.length == 1
							? 1 / 1
							: ctaBoxes.length > 2 && index == 0
							? 1 / 1
							: 16 / 9
					"
					:image-classes="[
						ctaBoxes.length > 2 && index == 0
							? 'block object-cover h-full'
							: ctaBoxes.length > 2 && index != 0
							? 'object-cover'
							: ctaBoxes.length == 1
							? 'object-cover h-full'
							: null,
					]"
				/>
			</div>
			<div
				:class="[
					'flex items-center px-20 py-30 >=768:px-0',
					ctaBoxes.length == 1
						? '>=768:w-half >=768:px-50 >=768:text-24'
						: null,
					ctaBoxes.length > 2 && index == 0
						? '>=768:w-half >=768:px-50 >=768:text-24'
						: null,
				]"
			>
				<div>
					<h3
						v-if="box.content.title"
						:class="[
							'leading-initial font-bold uppercase',
							ctaBoxes.length > 2 && index == 0
								? 'text-32'
								: null,
							ctaBoxes.length == 1 ? 'text-32' : null,
							(ctaBoxes.length > 2 && index != 0) ||
							ctaBoxes.length == 2
								? 'mb-15 text-20 >=768:text-24'
								: ':text-32 >=768:text-48 mb-15 >=768:mb-33',
						]"
						v-html="box.content.title"
					></h3>
					<p
						v-if="box.content.teaser"
						:class="[
							ctaBoxes.length > 2 && index == 0
								? 'text-14 >=768:text-24'
								: null,
							ctaBoxes.length == 1
								? 'text-14 >=768:text-24'
								: null,
						]"
						v-html="box.content.teaser"
					></p>
					<a
						v-if="box.content.link"
						v-tracking="
							`CTABox, Click, ${box.content.title} - ${getPath}`
						"
						:href="box.content.link.url"
						:target="box.content.link.target"
						class="
							group-hover:bg-action group-hover:cursor-pointer
							text-white
							bg-blue
							rounded-full
							uppercase
							px-25
							py-12
							inline-block
							mt-25
							font-semibold
							text-16
							>=768:mt-30
						"
						v-html="box.content.link.name"
					></a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UmbracoImageExt from '~/components/main/UmbracoImageExt';

export default {
	name: 'BlockListCustomCtaBoxesCustom',

	components: {
		UmbracoImageExt,
	},

	inheritAttrs: false,

	props: {
		ctaBoxes: Array,
	},

	computed: {
		getPath() {
			return this.$store.state.route.fullPath;
		},
	},
};
</script>
